

const apiConfig = {
  // Set the base URL for your API
  apiUrl: '/api/v1/',
};

export { apiConfig };
